import { openUploadWidget } from '../../utils/CloudinaryService';

const ImageUpload = ({ cloudName, uploadPreset, onImageUpload, title }) => {
  const uploadImageWidget = () => {
    const uploadWidget = openUploadWidget(
      {
        cloudName,
        uploadPreset,
      },
      (error, result) => {
        if (!error && result.event === 'success') {
          const publicId = result.info.public_id;
          onImageUpload(publicId);
        } else if (error) {
          console.error('Upload Error:', error);
        }
      }
    );
    uploadWidget.open();
  };

  return (
    <button
      type="button"
      className="text-white bg-gray-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
      onClick={uploadImageWidget}
    >
      {title}
    </button>
  );
};

export default ImageUpload;
